import "./App.scss";

import { FC, useEffect } from "react";

import { AppProvider } from "config/init/providers";
import { init as initApm } from "utils/elasticApm";

import { polyfill } from "smoothscroll-polyfill";

polyfill();

const App: FC = () => {
  useEffect(() => {
    initApm();
  }, []);

  return <AppProvider />;
};

export default App;
